import { useQuery } from "@tanstack/react-query";
import { analyticsApi } from "@bw/shared/api";
import type { PlayerProfileStatsResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * A player's PUBLIC profile stats payload (GET /analytics/players/{userId}/profile)
 * — the singles/doubles split + win rate + games + their last-10 `recent_matches`.
 *
 * Keyed by the PROFILED `userId` (never a viewer uid), so the same slot backs the
 * route-userId profile on PlayerStandingPage AND the viewer-uid profile on the
 * Compete hub's Profile tab. Disabled until a `userId` resolves AND until
 * `enabled` is true, so a lazily-mounted tab never eager-fetches (the hub passes
 * `enabled = tab === "profile"`).
 */
export function usePlayerProfile(userId: string | undefined, enabled = true) {
  return useQuery<PlayerProfileStatsResponse>({
    queryKey: queryKeys.compete.profile(userId ?? ""),
    queryFn: () => analyticsApi.getPlayerProfile(userId as string),
    enabled: Boolean(userId) && enabled,
  });
}
